import { Center, Spinner } from "native-base";
import React, { useCallback, useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import colors from "../../../constants/colors";
import API from "../../../api";
import { StatusContext } from "../../../contexts";
import routes from "../../../routes";

function PaymentResultPage() {
  const [searchParams] = useSearchParams();
  const status = useContext(StatusContext);
  const navigate = useNavigate();

  const getPayment = useCallback(async () => {
    try {
      const {
        data: { data },
      } = await API().get(`/payments/${searchParams.get("referencia")}`);
      if (data.source === "iframe" && data.type === "quotation") {
        window.location.href =
          "https://front-autotur-dev.lfr.cloud/mi-autotur?screen=5";
      } else if (data.source === "web" && data.type === "quotation") {
        navigate(routes.trips);
      }
    } catch (error) {
      status.updateErrorMessage(error);
    }
  }, [searchParams, status, navigate]);

  useEffect(() => {
    getPayment();
  }, [getPayment]);

  return (
    <Center height={400}>
      <Spinner size="lg" color={colors.primary} />
    </Center>
  );
}

export default PaymentResultPage;
